export function vimeoVideo() {
    let video = $(".vimeo-video");
    video.each(function () {
        let iframe = $(this);
        let iframeScr = iframe.data("src");
        iframe.attr("src", iframeScr);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/vimeoVideo.js